import isPropValid from '@emotion/is-prop-valid';

/**
 * Utility type to provide a subset of props that are used in the styles of a
 * styled component
 */
export type StyledProps<
  TStyledPropNames extends Readonly<string[]>,
  TComponentProps extends Partial<Record<TStyledPropNames[number], unknown>>,
> = Pick<TComponentProps, TStyledPropNames[number]>;

/**
 * Create a `shouldForwardProp` function for a styled component, using a
 * list of props that should not be forwarded
 * @param noForwardPropNames list of props not to be forwarded to the component
 */
export const shouldForwardProp = <TPropNames extends Readonly<string[]>>(
  noForwardPropNames?: TPropNames,
): typeof isPropValid => {
  if (!noForwardPropNames) {
    return isPropValid;
  }

  return (prop: string): boolean =>
    isPropValid(prop) && noForwardPropNames.indexOf(prop) === -1;
};
